import {Pipe, PipeTransform} from '@angular/core';
import {CustomLinkifyConfig, LinkifyService} from '@shared/services/ui/linkify/linkify.service';

@Pipe({
  name: 'linkify',
  standalone: false
})
export class LinkifyPipe implements PipeTransform {

  constructor(private linkifyService: LinkifyService) {
  }

  transform(value: string, customConfig?: CustomLinkifyConfig): string {
    return this.linkifyService.linky(value, customConfig);
  }
}
